<template>
    <v-select
        v-model    = "selected"
        :items     = "items"
        :label     = "label"
        :readonly  = "readonly"
        :disabled  = "readonly"
        :background-color = "background"
        item-value = "id"
        item-text  = "name"
        @change    = "onChange"
        :menu-props="{ maxHeight: 600 }"
        :hide-details = "hideDetails"
        class="pr-0"
    >
        <template v-slot:item="data">
            <v-hover v-slot="{ hover } " open-delay="0">
                <div
                    class="status-item v-flex"
                    :class="hover ? 'white--text' : ''"
                >
                    <v-icon
                        class = "status-icon"
                        :color= "hover ? 'white' : ''"
                    >
                        {{ data.item.font }} {{ 'fa-' + data.item.symbol}}
                    </v-icon>
                    <div class="status-name">{{data.item.name}}</div>
                </div>
            </v-hover>
        </template>
    </v-select>
</template>

<script>
export default {
    name : "IncStatus",
    props: {
        value: {
            required: true
        },
        items: {
            required: true
        },
        label: {
            required: false,
            default : function () {
                return 'Bearbeitungsstatus'
            }
        },
        readonly: {
            required: false,
            type    : Boolean,
            default : function () {
                return false
            }
        },
        hideDetails: {
            required: false,
            type    : Boolean,
            default : function () {
                return false
            }
        },
        background: {
            required: false,
            type    : String,
            default : function () {
                return null
            }
        }
    },

    data: () => ({
        selected: null
    }),

    mounted() {
        this.selected = this.value;
        if (!this.items.find (s => s.divider)) {
            const termintedIndex = this.items.findIndex (s => s.type === 'T');
            if (termintedIndex > 1) {
                this.items.splice (termintedIndex, 0, {
                    divider: true
                })
            }
        }
    },

    watch: {
        value () {
            this.selected = this.value;
        }
    },

    methods: {
        onChange () {
            let status = this.items.find (item => item.id === this.selected);
            this.$emit('input',  status);
            this.$emit('change', status);
        }
    }
}
</script>

<style scoped>

.status-icon {
    width: 30px;
    text-align: center;
}

.status-item {
    min-height: 35px;
    width: 100%;
}

.status-name {
    padding-top: 5px
}

::v-deep .v-list-item {
    padding-left: 5px;
    padding-right: 0;
}

</style>